import { Component } from '@angular/core';

@Component({
  selector: 'era-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss'],
})
export class MasterComponent {}
